import { memo } from "react";

const CopyIcon = memo(function CopyIcon({ className }: { className: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      id="Documents-Fill--Streamline-Mingcute-Fill"
      height="24"
      width="24"
      className={className}
    >
      <desc>Documents Fill Streamline Icon: https://streamlinehq.com</desc>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 0v16H0V0h16ZM8.395 15.505l-0.007 0.001-0.047 0.023-0.013 0.003-0.009-0.003-0.047-0.023c-0.007-0.003-0.013-0.001-0.016 0.003l-0.003 0.007-0.011 0.285 0.003 0.013 0.007 0.009 0.069 0.049 0.01 0.003 0.008-0.003 0.069-0.049 0.008-0.011 0.003-0.011-0.011-0.285c-0.001-0.007-0.006-0.011-0.011-0.012Zm0.177-0.075l-0.009 0.001-0.123 0.062-0.007 0.007-0.002 0.007 0.012 0.287 0.003 0.008 0.005 0.005 0.134 0.062c0.008 0.003 0.015 0 0.019-0.005l0.003-0.009-0.023-0.409c-0.002-0.008-0.007-0.013-0.013-0.015Zm-0.477 0.001a0.015 0.015 0 0 0-0.018 0.004l-0.004 0.009-0.023 0.409c0 0.008 0.005 0.013 0.011 0.016l0.01-0.001 0.134-0.062 0.007-0.005 0.003-0.007 0.011-0.287-0.002-0.008-0.007-0.007-0.123-0.061Z"
          strokeWidth="0.6667"
        ></path>
        <path
          fill="currentColor"
          d="M9.333 1.333v3.667A1 1 0 0 0 10.333 6H14v4.667a1.333 1.333 0 0 1-1.333 1.333h-1.333v1.333a1.333 1.333 0 0 1-1.333 1.333H4a1.333 1.333 0 0 1-1.333-1.333V5.333a1.333 1.333 0 0 1 1.333-1.333h1.333V2.667a1.333 1.333 0 0 1 1.333-1.333h2.667ZM5.333 5.333H4v8h6v-1.333h-3.333a1.333 1.333 0 0 1-1.333-1.333V5.333Zm5.333-3.971a1.333 1.333 0 0 1 0.667 0.362L13.61 4a1.333 1.333 0 0 1 0.362 0.667h-3.305V1.362Z"
          strokeWidth="0.6667"
        ></path>
      </g>
    </svg>
  );
});

export default CopyIcon;
